module.exports = __webpack_public_path__ + "assets/img/26_732_big.83f7dd76.jpg";